export function deriveTextEmbroideryFontFamilyFromStyle(fontStyle) {
    switch (fontStyle) {
        case 'Script':
            return 'VarsityScriptJF';
        case 'Block':
        default:
            return 'Helvetica';
    }
}
//# sourceMappingURL=utils.js.map